import React from "react";
import SEO from "../components/SEO";
import { organizationSchema, generateBreadcrumbSchema } from "../utils/schemaMarkup";

const About = () => {
  const breadcrumbSchema = generateBreadcrumbSchema([
    { name: "Home", url: "https://www.ceekayenterprise.com/" },
    { name: "About Us", url: "https://www.ceekayenterprise.com/about" },
  ]);

  const combinedSchema = {
    "@context": "https://schema.org",
    "@graph": [organizationSchema, breadcrumbSchema],
  };

  return (
    <div className="page active">
      <SEO
        title="About Ceekay Enterprise | 30+ Years of Excellence in Industrial Chemical Import | Mumbai, India"
        description="Learn about Ceekay Enterprise - established in 1992, a leading importer and supplier of industrial chemicals in India. 30+ years of experience, 500+ satisfied clients, serving construction, textiles, agriculture, and manufacturing industries with quality chemicals and reliable service."
        keywords="Ceekay Enterprise about, chemical importer Mumbai, industrial chemical company India, chemical supplier since 1992, Chetan Pandya Ceekay Enterprise"
        canonical="https://www.ceekayenterprise.com/about"
        schema={combinedSchema}
      />
      <h1 className="page-title">About Us</h1>
      <div className="about-content">
        <div className="about-text">
          <h3>Our Story</h3>
          <p>
            Established in the year 1992, Ceekay Enterprise has emerged as a
            leading importer and supplier of industrial chemicals, and specialty
            products. Based in Mumbai, Maharashtra, we have built a strong
            reputation for quality, reliability, and customer satisfaction over
            more than two decades.
          </p>

          <h3 style={{ marginTop: "0.5rem" }}>Our Mission</h3>
          <p>
            To be the preferred partner for businesses seeking high-quality
            industrial chemicals, providing innovative solutions that drive
            growth and success across various industries.
          </p>

          <h3 style={{ marginTop: "0.5rem" }}>Why Choose Us?</h3>
          <ul style={{ paddingLeft: "0rem", listStyleType: "none" }}>
            <li>✅ &nbsp;30+ Years of Industry Experience</li>
            <li>✅ &nbsp;Wide Range of Quality Products</li>
            <li>✅ &nbsp;Competitive Pricing</li>
            <li>✅ &nbsp;Timely Delivery</li>
            <li>✅ &nbsp;Excellent Customer Support</li>
          </ul>
        </div>

        <div className="about-text">
          <h3>Company Information</h3>
          <div style={{ marginTop: "1rem" }}>
            <p>
              <strong>CEO:</strong> Chetan Pandya
            </p>
            <p>
              <strong>Year Established:</strong> 1992
            </p>
            <p>
              <strong>Legal Status:</strong> Proprietorship
            </p>
            <p>
              <strong>GST Number:</strong> 27AAAPP8389F1ZA
            </p>
            <p>
              <strong>Annual Turnover:</strong> ₹24-25 Crore
            </p>
            <p>
              <strong>Nature of Business:</strong> Importer -
              Wholesaler/Distributor
            </p>
          </div>

          <h3 style={{ marginTop: "2rem" }}>Our Services</h3>
          <ul style={{ marginTop: "1rem", paddingLeft: "1.5rem" }}>
            <li>Import & Export of Industrial Chemicals</li>
            <li>Wholesale Distribution</li>
            <li>Custom Procurement Solutions</li>
            <li>Quality Testing & Certification</li>
            <li>Logistics & Supply Chain Management</li>
          </ul>
        </div>
      </div>

      <div className="company-stats">
        <div className="stat-item">
          <div className="stat-number">30+</div>
          <div className="stat-label">Years of Experience</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">500+</div>
          <div className="stat-label">Satisfied Clients</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">50+</div>
          <div className="stat-label">Product Categories</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">25Cr</div>
          <div className="stat-label">Annual Turnover</div>
        </div>
      </div>
    </div>
  );
};

export default About;
